import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datetimeFormat'
})
export class DatetimeFormatPipe implements PipeTransform {

  transform(dateInit: any): any {
    let formatDate = "";
    let date, hours, minutes;

    if(dateInit){
      date = new Date(dateInit)
      hours = (date.getHours() < 10) ? '0' + date.getHours() : date.getHours();
      minutes = (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes();
      formatDate = date.getDate() + " de " + this.setFormatMonth(date.getMonth()) + " de " + date.getFullYear() + " a las " + hours + ":" + minutes + " " + this.getMeridianFormat(date.getHours());
    }else{
      formatDate = '--';
    }

    return formatDate;
  }

  setFormatMonth(month: number){
    switch(month){
      case 0: return 'Enero'; case 1: return 'Febrero'; case 2: return 'Marzo'; case 3: return 'Abril'; case 4: return 'Mayo'; case 5: return 'Junio';
      case 6: return 'Julio'; case 7: return 'Agosto'; case 8: return 'Septiembre'; case 9: return 'Octubre'; case 10: return 'Noviembre'; case 11: return 'Diciembre';
    }
  }

  getMeridianFormat(hour: number){
    return (hour < 12) ? 'AM' : 'PM';
  }

}
